module.exports = __webpack_public_path__ + "img/toulouse.f3b3b1f9.png";